import {Component, OnInit} from '@angular/core';
import {ArticlesService} from "../articles.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.css']
})
export class ArticlesComponent implements OnInit {

  networkState:number =0;
  articles:Array<any> = [];
  errorMsg:string | null = null;
  page:number = 0;
  first:number = 0;
  size:number = 9;
  totalRecords:number =0;
  initialised: boolean = false;

  isEnglish:boolean = false;

  // @ts-ignore
  articlesService:ArticlesService;

  constructor(private articleService: ArticlesService, private router:Router) {
    this.articlesService = articleService;
  }

  ngOnInit(){
    this.first = this.size;

    this.getArticles();

  }

  onPageChange(event:any){
    this.size=event.rows;
    this.first = event.first;
    this.page = Math.round(event.first/this.size);

    this.getArticles();
  }

  getArticles(){
    this.networkState = 0;
    this.errorMsg = null;

    this.articleService.getArticles(`page=${this.page}&size=${this.size}&sort=created,desc`)
      .subscribe({
        next: (res) => {

          this.totalRecords = res.totalElements;

          this.articles = (res.list as Array<any>).map((a,_,__) =>{return {...a}});

          this.networkState = 1;
          this.initialised = true;

        },
        error: (error) => {
          this.errorMsg = error.message;
          this.networkState = 2;

        }
      });

  }

  viewArticle(articleId: string) {
    this.router.navigate(['/article', articleId]);
  }

}
